/**
 * 測定結果管理ページ用のスクリプト
 */
 if (is_route('terminal.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        terminal_event_set();
        terminal_setting_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
window.terminal_event_set = function() {
   
}

/**
 * 設定モーダル表示時のイベント設定
 */
 window.terminal_setting_event_set = function() {

}

